<template>
  <div class="footer-container">
     <footer>
          <div class="row m-0 pt-2 pb-1 footer-bar">
            <div class="col-auto footer-left">
              <img  :src="require('@/assets/icons/European_Union.svg')" alt="EU logo" style="height: 55px; margin: 0 26px; border: 1px solid white;"/>
              <span style="color: white;"><a href="https://ec.europa.eu/environment/marine/eu-coast-and-marine-policy/marine-strategy-framework-directive/index_en.htm">Funded by the European Union</a></span>
            </div>
             <div class=" ml-auto mr-auto pl-5 ">
              <img  :src="require('@/assets/QUIETMED2.png')" alt="QUIETMED2 Logo" class = "logo-icon"/>
            </div>
            <div class="col-auto float-right text-right ml-auto footer-right ">
              <img  :src="require('@/assets/icons/ctn_logo_white.svg')" alt="CTN Logo" style="height: 36px; margin: 10px 26px;"/>
            </div>
          </div>
      </footer>
 </div>
</template>

<script>
export default {
  name: 'quietmed2Footer',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  footer{
    position:fixed;
    bottom:0;
    width:100%;
    background-color: #00A7E3;
  }
  a {
    color: white;
    text-decoration: none;
  }
  a:link {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
  color: #aafaff
}

a:active {
  text-decoration: underline;
}

.logo-icon {
  height: 48px;
  margin: 3px 0px 3px 25%;
  width: 170px;
  object-fit: cover;
}
</style>
